module.exports = __webpack_public_path__ + "img/Alu-Zaun_1.e7f05c19.jpg";